import React from "react";

const Aboutus = () => {
  return (
    <div className="middle about-us-page">
      <div className="about-intro">
        <div className="container">
          <div className="heading-men">
            <h1>About Us</h1>
            <p className="welcome-text">
            </p>
            <p>
              Experience the Future of Car Cleaning with WashWoosh—Because We Care, You Shine!
            </p>
          </div>
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-6 col-md-7">
              <div
                className="about-text"
                data-aos="fade-down"
                data-aos-duration={2000}
              >

                <p className="welcome-text">
                  {/* <b>Welcome To WashWoosh</b> */}
                </p>
                <p>
                  In today's fast-paced world, convenience and efficiency are essential, and vehicle maintenance is
                  no exception. Traditional car washing methods often require vehicle owners to visit service
                  stations or depend on untrained cleaners who come home daily, using a single cloth to clean
                  everything—from the car’s body and dashboard to tires and mirrors—risking scratches and
                  damage.

                  <br /><br />
                  WashWoosh offers a hassle-free, professional, and   <strong className="highlight">safe doorstep car wash service in Jaipur,</strong>
                  ensuring your vehicle is cleaned with advanced tools, eco-friendly products, and trained cleaners
                  who follow best practices. Experience a scratch-free, spotless car without the inconvenience of
                  long queues or improper cleaning methods.
                </p>
              </div>
            </div>
            <div className="col-lg-5 col-md-5">
              <div
                className="banner-text banner-text-car text-end"
                data-aos="zoom-in-up"
                data-aos-duration={2000}
              >
                <img
                  className="img-fluid"
                  src="images/about-img.png"
                  alt="washwoosh car cleaning photo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="who-we-are how-it-works text-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 px-5">
              <div
                className="about-text"
                data-aos="fade-up"
                data-aos-duration={2000}
              >
                <h2>Who We Are</h2>
                <p className="welcome-text">
                </p>
                <p>
                  WashWoosh is a cutting-edge  <strong className="highlight">doorstep car wash service in Jaipur</strong> that provides professional
                  and eco-friendly car cleaning solutions right at your home. Launched in  <strong className="highlight">November 2024,</strong> our
                  company was founded with the vision of offering car owners a seamless, convenient, and reliable
                  alternative to traditional car washes.

                  <br /><br />
                  With our easy-to-use <strong className="highlight">doorstep car wash booking app,</strong> customers can schedule a wash anytime,
                  anywhere, without disrupting their daily routine. Our expert team of  <strong className="highlight">20+ trained car cleaners</strong>
                  uses high-quality products and advanced techniques to ensure your vehicle is spotless, wellmaintained, and protected from environmental damage
                  <br /><br />
                  Currently, WashWoosh operates in key areas of  <strong className="highlight">Jaipur,</strong> including  <strong className="highlight">Jagatpura, Pratap Nagar,
                    Sanganer, Gopalpura, Durgapura,</strong> and  <strong className="highlight">Malviya Nagar,</strong> and we’re rapidly expanding to other
                  cities. Choose WashWoosh for a hassle-free car cleaning experience, delivered right to your
                  doorstep!
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="middle-banner our-mission">
        <div className="container-fluid mission-container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-6 col-md-7">
              <div
                className="about-text"
                data-aos="fade-up"
                data-aos-duration={2000}
              >
                <h2>Our Mission</h2>
                <p className="welcome-text">
                </p>
                <p>
                  At WashWoosh, our mission is to revolutionize car cleaning by offering a doorstep car wash
                  service in Jaipur that is fast, reliable, and eco-friendly. We are dedicated to saving our
                  customers time while delivering high-quality cleaning solutions that protect both their vehicles
                  and the environment. Through advanced cleaning techniques and sustainable products, we aim to
                  provide a convenient alternative to traditional car washes.
                </p>
              </div>
            </div>
            <div className="col-lg-5 col-md-5">
              <div
                className="banner-text banner-text-car text-end"
                data-aos="zoom-in-up"
                data-aos-duration={2000}
              >
                <img
                  className="img-fluid"
                  src="images/mission.jpg"
                  alt="Doorstep Car Wash Service In Jaipur With WashWoosh"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="final-thoughts">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-6 col-md-7">
              <div
                className="about-text"
                data-aos="fade-up"
                data-aos-duration={2000}
              >
                <h2>Our Promise</h2>
                <p className="welcome-text">
                </p>
                <p>

                  At <strong className="highlight">WashWoosh</strong>, we’re more than just a car wash service—we’re transforming the way vehicles
                  are cared for. By combining <strong className="highlight">doorstep convenience</strong>, skilled professionals, and <strong className="highlight">eco-friendly
                    practices</strong>, we provide a superior alternative to traditional car washes. Whether you’re a busy
                  professional, a homemaker, or someone who values their time, <strong className="highlight">WashWoosh</strong> ensures that
                  keeping your car clean is both effortless and stress-free.

                  <br /><br />
                  <strong className="highlight">"We Care You Shine"</strong> isn’t just our tagline—it’s our promise. We’re committed to delivering
                  exceptional service that leaves your car spotless, shining, and well-maintained. We continuously
                  learn from everyday market challenges, striving to enhance our services, boost productivity, and
                  improve customer satisfaction—ensuring we stay ahead of all your <strong className="highlight">car care needs in Jaipur</strong> and
                  beyond.
                  <br /><br />
                  Looking for reliable <strong className="highlight">doorstep car cleaning in Jaipur?</strong> We’re here to make car maintenance
                  simple, efficient, and sustainable. If you have any questions or would like to schedule a service,
                  feel free to reach out!
                  <br /><br />
                  <strong className="highlight">Experience the Future of Car Cleaning with WashWoosh—Because We Care, You Shine!</strong>
                </p>
              </div>
            </div>
            <div className="col-lg-5 col-md-5">
              <div
                className="banner-text banner-text-car text-end"
                data-aos="zoom-in-up"
                data-aos-duration={2000}
              >
                <img
                  className="img-fluid"
                  src="images/final-thoughts.png"
                  alt="Expert & Skilled Cleaners"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="faq-accordion">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div
                className="about-text"
                data-aos="fade-up"
                data-aos-duration={2000}
              >
                <h2 class="text-center">Frequently Asked Questions</h2>
                <p class="welcome-text"></p>

              </div>

              <div class="accordion" id="faqAccordion">

                <div class="accordion-item">
                  <h2 class="accordion-header" id="faqHeading1">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse1" aria-expanded="true" aria-controls="faqCollapse1">
                      What is WashWoosh?
                    </button>
                  </h2>
                  <div id="faqCollapse1" class="accordion-collapse collapse show" aria-labelledby="faqHeading1" data-bs-parent="#faqAccordion">
                    <div class="accordion-body">
                      <p><strong>WashWoosh is Jaipur’s</strong> leading <strong>doorstep car wash service</strong>, offering professional cleaning at your home or office. Just book through our mobile app and let our trained team handle your car's cleanliness with eco-friendly methods.</p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="faqHeading2">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse2" aria-expanded="false" aria-controls="faqCollapse2">
                      How can I book a car wash with WashWoosh?
                    </button>
                  </h2>
                  <div id="faqCollapse2" class="accordion-collapse collapse" aria-labelledby="faqHeading2" data-bs-parent="#faqAccordion">
                    <div class="accordion-body">
                      <p> Download the <strong>WashWoosh app</strong> from the<a href="https://play.google.com/store/apps/details?id=com.washwoosh.userapp&pcampaignid=web_share" aria-label="Download WashWoosh App From Paly Store For Android Users" target="_blank" class="ms-2 me-2">
                        Play Store
                      </a> or <a href="https://apps.apple.com/in/app/washwoosh-car-care-app/id6738276020" aria-label="Download WashWoosh App From App Store For ios Users" target="_blank" class="ms-2">App Store</a>, register your vehicle, select your preferred service, choose a time slot, and we’ll be there—no hassle, no waiting.</p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="faqHeading3">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse3" aria-expanded="false" aria-controls="faqCollapse3">
                      Which locations does WashWoosh serve in Jaipur?
                    </button>
                  </h2>
                  <div id="faqCollapse3" class="accordion-collapse collapse" aria-labelledby="faqHeading3" data-bs-parent="#faqAccordion">
                    <div class="accordion-body">
                      <p> WashWoosh is currently available in <strong>Jagatpura, Malviya Nagar, Gopalpura, Durgapura, Pratap Nagar,</strong> and <strong>Sanganer</strong>. We are expanding to more areas soon.</p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="faqHeading4">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse4" aria-expanded="false" aria-controls="faqCollapse4">
                      Do I get a welcome kit with my subscription?
                    </button>
                  </h2>
                  <div id="faqCollapse4" class="accordion-collapse collapse" aria-labelledby="faqHeading4" data-bs-parent="#faqAccordion">
                    <div class="accordion-body">

                      <p>Yes! Every <strong>monthly and quarterly subscription</strong> comes with a <strong>welcome kit delivered every month</strong>, which includes: <br />
                        <ol class="mt-3 ps-3 list-style-disc">
                          <li>A <strong>car air freshener</strong></li>
                          <li>A <strong>tissue box</strong></li>
                          <li>A set of <strong>paper mates</strong> (disposable paper mats for your car floor)</li>
                        </ol>
                        This kit ensures your car stays fresh, clean, and hygienic—making your doorstep car wash experience even better with WashWoosh.</p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="faqHeading5">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse5" aria-expanded="false" aria-controls="faqCollapse5">
                      What car cleaning services are offered?
                    </button>
                  </h2>
                  <div id="faqCollapse5" class="accordion-collapse collapse" aria-labelledby="faqHeading5" data-bs-parent="#faqAccordion">
                    <div class="accordion-body">

                      <p>We offer a complete range of <strong>interior and exterior car wash services</strong>, including:<br />
                        <ol class="mt-3 ps-3 list-style-disc">
                          <li><strong>Exterior washing</strong></li>
                          <li><strong>Interior vacuuming</strong></li>
                          <li><strong>Dashboard polishing</strong></li>
                          <li><strong>Tyre polishing</strong></li>
                          <li><strong>Waterless wash</strong></li>
                          <li><strong>Dry cleaning</strong></li>
                        </ol>
                        All services are provided at your doorstep by trained professionals.</p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="faqHeading6">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse6" aria-expanded="false" aria-controls="faqCollapse6">
                      Are the cleaning products safe for my car?
                    </button>
                  </h2>
                  <div id="faqCollapse6" class="accordion-collapse collapse" aria-labelledby="faqHeading6" data-bs-parent="#faqAccordion">
                    <div class="accordion-body">
                      <p>Absolutely! WashWoosh uses <strong>eco-friendly and non-abrasive products</strong> that are safe for all car surfaces and interiors</p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="faqHeading7">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse7" aria-expanded="false" aria-controls="faqCollapse7">
                      Do I need to provide water or electricity?
                    </button>
                  </h2>
                  <div id="faqCollapse7" class="accordion-collapse collapse" aria-labelledby="faqHeading7" data-bs-parent="#faqAccordion">
                    <div class="accordion-body">
                      <p>No, you don’t need to provide anything. Our cleaning team comes fully equipped with water, electricity, and all cleaning materials.</p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="faqHeading8">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse8" aria-expanded="false" aria-controls="faqCollapse8">
                      What are WashWoosh subscription plans?
                    </button>
                  </h2>
                  <div id="faqCollapse8" class="accordion-collapse collapse" aria-labelledby="faqHeading8" data-bs-parent="#faqAccordion">
                    <div class="accordion-body">
                      <p>WashWoosh offers flexible car wash plans to suit your needs:<br />
                        <ol class="mt-3 ps-3 list-style-disc">
                          <li><strong>One-Day Service</strong></li>
                          <li><strong>Monthly Car Wash Plans</strong></li>
                          <li><strong>Quarterly Car Wash Plans</strong></li>
                        </ol>
                        Each plan includes regular scheduling, premium quality service, and monthly Welcome Kits. All bookings and plan management are done through the app.</p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="faqHeading9">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse9" aria-expanded="false" aria-controls="faqCollapse9">
                      Can I book a wash for more than one car?
                    </button>
                  </h2>
                  <div id="faqCollapse9" class="accordion-collapse collapse" aria-labelledby="faqHeading9" data-bs-parent="#faqAccordion">
                    <div class="accordion-body">
                      <p>Yes! You can add and manage <strong>multiple cars</strong> under one WashWoosh account and schedule services for each vehicle individually</p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="faqHeading10">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse8" aria-expanded="false" aria-controls="faqCollapse8">
                      How much does a car wash cost with WashWoosh?
                    </button>
                  </h2>
                  <div id="faqCollapse8" class="accordion-collapse collapse" aria-labelledby="faqHeading10" data-bs-parent="#faqAccordion">
                    <div class="accordion-body">
                      <p>Pricing starts at <strong>₹249 for a one-day service</strong>.
                        Our <strong>monthly subscription plans start from just ₹699 onwards</strong>, offering better value and consistent car care. Full pricing details are available in the WashWoosh app.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="faqHeading11">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse9" aria-expanded="false" aria-controls="faqCollapse9">
                      Is WashWoosh available outside Jaipur?
                    </button>
                  </h2>
                  <div id="faqCollapse9" class="accordion-collapse collapse" aria-labelledby="faqHeading11" data-bs-parent="#faqAccordion">
                    <div class="accordion-body">
                      <p>We are currently operating in <strong>Jaipur</strong> but will soon expand in the coming months.</p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="faqHeading12">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse10" aria-expanded="false" aria-controls="faqCollapse10">
                      Is there customer support if I need help?
                    </button>
                  </h2>
                  <div id="faqCollapse10" class="accordion-collapse collapse" aria-labelledby="faqHeading12" data-bs-parent="#faqAccordion">
                    <div class="accordion-body">
                      <p>Yes! For any queries or support, contact us at <a
                        href="tel:1800-2700-722" className="contact-links"
                        aria-label="Call Company Name at 1800-2700-722"
                      >
                        <i className="fa-solid fa-phone me-2" />
                        1800-2700-722
                      </a> or reach out via the <strong>WashWoosh app chat support</strong>. We’re here to help!</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="At-fingertips-men">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-12 col-md-12"
              data-aos="zoom-in"
              data-aos-duration={2000}
            >
              <div className="At-fingertips-left">
                <div className="heading-men p-0">
                  <img
                    className="app-icon-photo"
                    src="images/app-icon.png"
                    alt="Download Icon"
                  />
                  <h2>At your doorstep, at your fingertips</h2>
                  <p className="pt-2">
                    Experience the most convenient, professional, and
                    eco-friendly car wash solution—just a tap away!
                  </p>
                  <div className="all-btn">
                    <div className="row mt-4 justify-content-center">
                      <div className="col-lg-2 play">
                        <div className="btn1 btn2">
                          <a href="https://play.google.com/store/apps/details?id=com.washwoosh.userapp&pcampaignid=web_share" aria-label="Download WashWoosh App From Paly Store For Android Users">
                            <img
                              className="img-fluid"
                              src="images/d-app1.png"
                              alt="Play Store Icon"
                            />
                          </a>
                        </div>

                        <div className="btn1 btn2">
                          <a href="https://apps.apple.com/in/app/washwoosh-car-care-app/id6738276020" aria-label="Download WashWoosh App From App Store For ios Users">
                            <img
                              className="img-fluid"
                              src="images/d-app2.png"
                              alt="App Store Icon"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>);
};

export default Aboutus;
